<template>
  <div class="header">
    <div class="row">
      <div class="col-lg-3 col-12">
        <h1 v-if="!isLink">
          {{ title }}
        </h1>
        <h1 v-if="isLink">
          <router-link :to="linkData">
            <font-awesome-icon
              :icon="['far', 'chevron-left']"
              size="lg"
            /> {{ title }}
          </router-link>
        </h1>
      </div>
      <div class="col-lg-9 col-12 text-right">
        <slot v-if="!showSaveAndContinue" />
        <form @submit.prevent="saveAndContinue">
          <div
            v-if="showCampaignName"
            class="d-inline"
          >
            <span class="mr-3 required">Campaign Name:</span>
            <div class="e-float-input creating-campaign-input">
              <input
                v-model="campaignName"
                class="e-input"
                type="text"
                required
              >
            </div>
          </div>
          <button
            v-if="showSaveAndContinue"
            id="saveAndContinue"
            type="submit"
            class="btn btn-lg btn-primary px-4 white ml-3"
            :disabled="!selectedTemplate || (isCreatingCampaign && !campaignName)"
          >
            Save & Continue
          </button>
        </form>
      </div>
    </div>
    <div v-if="showSaveAndContinue">
      <hr class="divider">
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { iframeParentCommunication } from '@/mixins/iframeParentCommunication'

export default {
  name: 'TemplateBuilderHeader',
  mixins: [iframeParentCommunication],
  props: {
    title: String,
    isLink: Boolean,
    link: String
  },
  data () {
    return {
      campaignName: null,
      linkData: { name: this.link }
    }
  },
  computed: {
    ...mapGetters({
      selectedTemplate: 'getSelectedTemplate'
    }),
    ...mapState({
      isCreatingCampaign: state => state.templateBuilder.isCreatingCampaign
    }),
    showSaveAndContinue () {
      return this.$router.currentRoute.name === 'TemplateBuilder' && this.$route.query.isSearchingTemplate === 'true'
    },
    showCampaignName () {
      return this.$router.currentRoute.name === 'TemplateBuilder' && this.isCreatingCampaign
    }
  },
  methods: {
    saveAndContinue () {
      if (this.showSaveAndContinue) {
        let editorOption = ''
        switch (this.selectedTemplate.editorTypeId) {
          case 2:
            editorOption = 'DragDrop'
            break
          case 3:
            editorOption = 'Legacy'
            break
          default:
            editorOption = 'CendynEditor'
        }
        const data = { action: 'eIn_save_and_continue', value: this.selectedTemplate.id, editorOption, campaignName: this.campaignName }
        this.SendMessageToParent(data)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.required::after {
  content: '*';
  color: $red;
  margin-left: 3px;
}

.divider {
  border-top: 1px solid #dee2e6
}

.header {
  &__actions {
    margin-left: 10px;
  }
  h1 {
    color: #000;
    a {
      text-decoration: none;
      color: #000;
      cursor: pointer;
      .fa-lg {
        vertical-align: -0.2rem;
        margin-right: 7px;
        color: #24245A;
      }
    }
  }
}

.creating-campaign-input {
  width: 55%;
  max-width: 500px;
}
</style>
